import React from "react"
import { ChevronRight, ChevronLeft, Lock } from "lucide-react"
import "./SidePanel.css"

const SidePanel = ({
    hoveredCountry,
    countryInfo,
    regionsMap,
    panelOpen,
    togglePanel,
    setLockedCountry,

    lockedCountry,
    lockedRegion,
    setLockedRegion,
    hoveredRegion,
  }) => {

  if (!panelOpen) {
    return (
      <div className="side-panel-handle">
        <button
          onClick={togglePanel}
          className="side-panel-open-btn"
          aria-label="Open info panel"
        >
          <ChevronLeft size={18} />
        </button>
      </div>
    )
  }

  return (
    <div className="side-panel">
      <div className="side-panel-inner">
        {/* Header */}
        <div className="side-panel-header">
          <div
            className="side-panel-lock-toggle"
            onClick={() => {
              if (lockedCountry) setLockedCountry(null)
              else if (hoveredCountry) setLockedCountry(hoveredCountry)

              if (lockedRegion) setLockedRegion(null)
              else if (hoveredRegion) setLockedRegion(hoveredRegion)
            }}
          >
            {(lockedCountry || lockedRegion) && <Lock size={14} color="var(--primary)" />}
            {lockedCountry
              ? `Country info locked (${lockedCountry})`
              : lockedRegion
                ? `Region info locked (${lockedRegion})`
                  : "Right-click to lock info"}
          </div>

          <button onClick={togglePanel} className="side-panel-close-btn" aria-label="Close info panel">
            <ChevronRight size={18} />
          </button>
        </div>

        {/* Content */}
        <div className="side-panel-content">
          {hoveredCountry ? (
            <>
              <h4>{countryInfo[hoveredCountry]?.name || hoveredCountry}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    countryInfo[hoveredCountry]?.description ||
                    "Description unavailable.",
                }}
              />
            </>
          ) : hoveredRegion ? (
            <>
              <h4>{regionsMap[hoveredRegion]?.name}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    countryInfo[hoveredCountry]?.description ||
                    "Description unavailable.",
                }}
              />
            </>
          ) : (
            <p className="side-panel-placeholder">
              Hover over to see details
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default SidePanel
